export const plans = [
  {
    name: "Starter",
    price: 10,
  },
  {
    name: "Pro",
    price: 29,
  },
  {
    name: "Enterprise",
    price: 99,
  },
];
